import React, { useEffect, useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import CampaignOutlined from '@mui/icons-material/CampaignOutlined';
import { tokens } from '../../theme';
import useAnnouncementService from '../../api/services/announcementService';
import LoadingSpinner from '../../components/LoadingSpinner';
import { getUserFromCookies } from '../../utils/Cookie-utils';
import ReadOnlyAnnouncementCard from './ReadOnlyAnnouncementCard';

const ParentsAnnouncement = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isDark = theme.palette.mode === 'dark';
  const headerTitleColor = isDark ? colors.grey[100] : colors.primary[600];
  const headerSubColor = isDark ? colors.grey[300] : colors.grey[500];

  const user = getUserFromCookies();
  const parentId = user?.data?.id;

  const { getAnnouncementsByParent, isLoading } = useAnnouncementService();
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAnnouncements = async () => {
      if (!parentId) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const data = await getAnnouncementsByParent(parentId);
        setAnnouncements(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Failed to load parent announcements:', error);
        setAnnouncements([]);
      } finally {
        setLoading(false);
      }
    };

    loadAnnouncements();
  }, [parentId]);

  if (loading) {
    return <LoadingSpinner message="Loading matangazo..." height="60vh" />;
  }

  return (
    <Box p={2} ml={2} mr={2}>
      <Box mb={2}>
        <Typography variant="h5" fontWeight={700} sx={{ color: headerTitleColor }}>
          Matangazo
        </Typography>
        <Typography variant="body2" sx={{ color: headerSubColor, fontWeight: 500 }}>
          Matangazo ya madarasa ya watoto wako
        </Typography>
      </Box>

      {isLoading ? (
        <LoadingSpinner message="Loading matangazo..." height="240px" />
      ) : announcements.length > 0 ? (
        <Box display="flex" flexWrap="wrap" gap={2} alignItems="stretch">
          {announcements.map((announcement) => (
            <ReadOnlyAnnouncementCard
              key={announcement.id}
              announcement={announcement}
              colors={colors}
            />
          ))}
        </Box>
      ) : (
        <Box
          p={4}
          textAlign="center"
          sx={{
            borderRadius: '18px',
            backgroundColor: colors.primary[400],
            border: `1px solid ${alpha(colors.grey[100], isDark ? 0.08 : 0.16)}`,
            boxShadow: isDark
              ? '0 8px 22px rgba(0,0,0,0.28)'
              : '0 10px 24px rgba(20, 27, 45, 0.18)',
          }}
        >
          <CampaignOutlined
            sx={{
              fontSize: 48,
              color: isDark ? alpha('#ffffff', 0.7) : colors.primary[600],
              mb: 1,
            }}
          />
          <Typography sx={{ color: isDark ? '#ffffff' : colors.grey[100] }} fontWeight={600}>
            Hakuna matangazo kwa sasa.
          </Typography>
          <Typography
            variant="body2"
            sx={{
              mt: 1,
              color: isDark ? alpha('#ffffff', 0.82) : colors.primary[600],
            }}
          >
            Matangazo ya madarasa ya watoto wako yataonekana hapa.
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ParentsAnnouncement;
